import { useQuery } from '@tanstack/react-query';
import { terraProxyApiClient } from '../../clients/testerClient';

export const EXTERNAL_NETWORK_STATS_KEY = 'external-network-stats';

const STALE_TIME_MS = 30_000;

export function useExternalNetworkStats(surfaceId: string | null) {
  const query = useQuery({
    queryKey: [EXTERNAL_NETWORK_STATS_KEY, surfaceId],
    queryFn: () => terraProxyApiClient.getExternalNetworkStats(surfaceId ?? ''),
    enabled: Boolean(surfaceId),
    staleTime: STALE_TIME_MS,
  });

  return {
    stats: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
}
